import { useEffect, useMemo, useState } from 'react';

import { debounce } from '@/shared/services/tools';

const useDebouncedValue = <T>(value: T, delay: number = 300) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  const handleValueChanged = useMemo(
    () => debounce((value: T) => setDebouncedValue(value), delay),
    [delay]
  );

  useEffect(() => {
    if (delay < 0) {
      setDebouncedValue(value);
      return;
    }
    handleValueChanged(value);
  }, [delay, value, handleValueChanged]);

  return debouncedValue;
};

export default useDebouncedValue;
